import styled from 'styled-components';

export const Required = styled.span.attrs({
    className: 'text-danger',
    children: ' *',
})`
    font-weight: bold;
`;
